import { cn } from '@tractian/ui'

type PageLoaderProps = {
  className?: string
  'data-testid'?: string
}

/**
 * Full-area page loader — the brand dot animation (identical to web-v1's
 * `lds-ellipsis`), centered and filling its container. Use for page/route-level
 * loads (lazy routes, initial page data, dashboard regions) so the whole surface
 * shows one indicator instead of several skeletons popping in out of sync.
 *
 * Fades in after a short delay (`page-loader-fade-in`, see styles.css): fast
 * loads finish before the delay elapses, so the loader never flashes on screen.
 * No text label — matches v1 and avoids the untranslated "Loading…" flash before
 * i18n resources are ready.
 */
export function PageLoader({ className, 'data-testid': dataTestId = 'page-loader' }: PageLoaderProps) {
  return (
    <div
      role="status"
      aria-label="Loading"
      aria-busy="true"
      data-testid={dataTestId}
      className={cn(
        'page-loader-fade-in flex size-full items-center justify-center',
        className
      )}
    >
      <div className="lds-ellipsis" aria-hidden>
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  )
}
